
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doubts",
      function () {
        return require("private-next-pages/doubts.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doubts"])
      });
    }
  